export default __webpack_public_path__ + "static/parallax-profesional-trabajando-b7d34c581c76b533a5bb96aca185a457.jpg";